// @ts-strict-ignore
/* eslint-disable camelcase */
import classNames from 'classnames'
import React from 'react'

interface LabelProps {
  children: React.ReactNode
  htmlFor?: string
}

interface FieldProps {
  children: React.ReactNode
  stack?: boolean
}

export const Label = ({ children, htmlFor }: LabelProps) => {
  return <label htmlFor={htmlFor}>{children}</label>
}

export const FieldGroup = ({ children, type = 'default', stack = false }) => {
  return (
    <div
      className={classNames(
        'FieldGroup',
        {
          FieldGroup__stack: stack,
        },
        { 'FieldGroup--first-small': type === 'first-small' },
      )}
    >
      {children}
    </div>
  )
}

const Field = ({ children, stack = false }: FieldProps) => {
  return <div className={classNames('Field', { Field__stack: stack })}>{children}</div>
}

export default Field
